import { BaseSystemModel, Guid, RecursivePartial } from '@models/base';

export class TaskStats extends BaseSystemModel {
    shortId!: string;
    orgId!: Guid;
    subj!: string;
    stateId!: Guid;
    assignee?: Guid;
    assigneeGroup?: Guid;
    projectId?: Guid;
    dueDate?: Date;
    priority: number = 0;
    pluginId?: Guid;
    type: number = 0;
    filesCount: number = 0;
    filesSize: number = 0;

    _percent: number = 0;
    _percentReal: number = 0;

    constructor(json?: RecursivePartial<TaskStats>) {
        super(json);
        this.parseTaskStats(json || {});
    }

    parse(json: RecursivePartial<TaskStats>): TaskStats {
        super.parse(json);
        this.parseTaskStats(json);
        return this;
    }

    private parseTaskStats(json: RecursivePartial<TaskStats>): void {
        TaskStats.assignFields(this, json, [
            'shortId',
            'orgId',
            'stateId',
            'subj',
            'assignee',
            'assigneeGroup',
            'projectId',
            'priority',
            'pluginId',
            'type',
            'filesCount',
            'filesSize',
        ]);
        TaskStats.assignDates(this, json, ['dueDate']);
        if (this.priority > 3) {
            this.priority = 3;
        }
    }

}
